export default __webpack_public_path__ + "static/media/deahomesmob.44c27d34.jpg";